var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOgwhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1586.11 914.99",
    style: {
      enableBackground: "new 0 0 1586.11 914.99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "901.37,189.01 697.07,548.79 638.09,651.07 579.12,548.79 525.28,455.63 575.39,368.9 627.3,278.96  638.09,260.2 679.21,189.01 788.3,0 1323.09,0 1484.09,278.96 1262.05,278.96 1210.14,189.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1320.9,914.99 882.23,914.99 990.81,727.01 991.96,725.08 1210.14,725.08 1311.91,548.79  1093.73,548.79 1146.41,457.56 1095.27,368.9 1536,368.9 1586.11,455.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,457.56 264.05,0 685.51,0 576.42,189.01 373.78,189.01 218.95,457.05 373.78,725.08 683.32,725.08  945.83,265.85 1056.47,457.56 792.28,914.99 264.05,914.99  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOgwhite);
export default __webpack_public_path__ + "static/media/ogwhite.b9ccce7311b2bdf935fed503054216a5.svg";
export { ForwardRef as ReactComponent };